import React from 'react';
import styled from 'styled-components';

export const BPMSliderContainer = styled.div`
    position: absolute;
    ${props => {
        const layout = props.layout || {};
        let styles = '';
        if (layout.top !== undefined) styles += `top: ${typeof layout.top === 'string' ? layout.top : `${layout.top}px`}; `;
        if (layout.right !== undefined) styles += `right: ${typeof layout.right === 'string' ? layout.right : `${layout.right}px`}; `;
        if (layout.bottom !== undefined) styles += `bottom: ${typeof layout.bottom === 'string' ? layout.bottom : `${layout.bottom}px`}; `;
        if (layout.left !== undefined) styles += `left: ${typeof layout.left === 'string' ? layout.left : `${layout.left}px`}; `;
        if (layout.width !== undefined) styles += `width: ${typeof layout.width === 'string' ? layout.width : `${layout.width}px`}; `;
        if (layout.height !== undefined) styles += `height: ${typeof layout.height === 'string' ? layout.height : `${layout.height}px`}; `;
        if (layout.transform) styles += `transform: ${layout.transform}; `;
        return styles;
    }}
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    z-index: 10;
`;

export const BPMSlider = styled.div`
    position: relative;
    width: 6px;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 3px;
    border: 1px solid rgba(244, 212, 163, 0.2);
    box-shadow: inset 2px 0 4px rgba(0, 0, 0, 0.5);
    cursor: pointer;
`;

export const BPMSliderTrack = styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: ${props => props.value || 60}%;
    background: linear-gradient(180deg, rgba(244, 212, 163, 0.4) 0%, rgba(244, 212, 163, 0.2) 100%);
    border-radius: 3px;
    transition: height 0.3s ease;
`;

export const BPMSliderHandle = styled.div`
    position: absolute;
    left: 50%;
    bottom: ${props => props.value || 60}%;
    transform: translate(-50%, 50%);
    width: 24px;
    height: 8px;
    background: linear-gradient(180deg, #4a4a4a 0%, #2a2a2a 100%);
    border: 2px solid rgba(244, 212, 163, 0.5);
    border-radius: 4px;
    box-shadow: 
        0 2px 6px rgba(0, 0, 0, 0.5),
        inset 0 1px 2px rgba(0, 0, 0, 0.3);
    cursor: grab;
    transition: all 0.2s ease;
    z-index: 3;

    &:hover {
        border-color: rgba(244, 212, 163, 0.8);
        box-shadow: 
            0 2px 8px rgba(244, 212, 163, 0.4),
            inset 0 1px 2px rgba(0, 0, 0, 0.3);
        transform: translate(-50%, 50%) scale(1.1);
    }

    &:active {
        cursor: grabbing;
        transform: translate(-50%, 50%) scale(0.95);
    }
`;

export const BPMMarkers = styled.div`
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    width: 80px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`;

export const BPMMarker = styled.div`
    position: absolute;
    top: ${props => props.position === 'top' ? '0%' : props.position === 'middle' ? '50%' : '100%'};
    left: 50%;
    transform: ${props => {
        const yTransform = props.position === 'middle' ? 'translate(-50%, -50%)' : props.position === 'bottom' ? 'translate(-50%, -100%)' : 'translateX(-50%)';
        return yTransform;
    }};
    font-size: 0.6rem;
    color: rgba(244, 212, 163, 0.6);
    font-weight: 600;
    white-space: nowrap;
    width: 80px;
    text-align: left;
    padding-left: calc(50% - 14px - 8px);
    line-height: 1;

    &::after {
        content: '';
        width: 28px;
        height: 1px;
        background: rgba(244, 212, 163, 0.4);
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 50%;
    }
`;

export const BPMValue = styled.div`
    position: absolute;
    top: -15px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.9rem;
    color: rgba(244, 212, 163, 0.9);
    font-weight: 600;
    font-family: 'Courier New', monospace;
    text-align: center;
    width: 100%;
`;

const BPMSliderComponent = ({ value, onMouseDown }) => {
    return (
        <div style={{ position: 'relative', width: '100%', height: '100%', marginTop: '8px' }}>
            <BPMMarkers>
                <BPMMarker position="top">-</BPMMarker>
                <BPMMarker position="middle">0</BPMMarker>
                <BPMMarker position="bottom">+</BPMMarker>
            </BPMMarkers>
            <BPMSlider 
                data-bpm-slider
                onMouseDown={onMouseDown}
                style={{ position: 'absolute', right: 0, top: 0 }}
            >
                <BPMSliderTrack value={value} />
                <BPMSliderHandle value={value} />
            </BPMSlider>
        </div>
    );
};

export default BPMSliderComponent;

